// extracted by mini-css-extract-plugin
export default {"contactItem":"style_contactItem__P68jz","contactItemLogo":"style_contactItemLogo__QLYpC","itemInfo":"style_itemInfo__w1fEF"};